<template>
  <v-app :style="{ backgroundColor: '#F5F7FA' }">
    <v-navigation-drawer v-model="drawer" app clipped class="elevation-2">
      <v-list dense nav>
        <v-list-item
          v-for="item in menuItems"
          :key="item.title"
          link
          @click="goToRoute(item.route)"
        >
          <v-list-item-icon>
            <v-icon :color="getThemeColor">{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }} </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

      <div class="pa-4 text-center">
        <div class="text-subtitle-2 font-weight-bold">
          {{ getUserCompany.name }}
        </div>
        <div class="text-caption grey--text">{{ getUserCompany.city }}</div>
      </div>
    </v-navigation-drawer>

    <v-app-bar app clipped-left color="white" flat class="border-bottom">
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title class="font-weight-black text-h5">
        <span :style="{ color: getThemeColor }">MyOffice</span> Online
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-menu offset-y transition="slide-y-transition">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            :color="getThemeColor"
            dark
            rounded
            depressed
            class="mr-4 d-none d-sm-flex"
          >
            <v-icon left>mdi-lightning-bolt</v-icon> Quick Action
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="act in quickActions"
            :key="act.title"
            @click="handleAction(act.action)"
          >
            <v-list-item-icon
              ><v-icon :color="act.color">{{
                act.icon
              }}</v-icon></v-list-item-icon
            >
            <v-list-item-title>{{ act.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-avatar size="35" class="mr-2">
        <v-icon color="red">mdi-account</v-icon>
      </v-avatar>
      <div class="d-none d-md-block text-body-2 font-weight-medium">
        {{ getCurrentUser.name }} <br /><small>{{ getCurrentUser.role }}</small>
      </div>
    </v-app-bar>

    <v-main>
      <div fluid class="pa-6">
        <v-row dense class="px-2">
          <v-col
            cols="12"
            sm="6"
            md="3"
            v-for="kpi in financialKPIs"
            :key="kpi.title"
          >
            <v-card class="rounded-lg elevation-1 pa-4">
              <div class="d-flex align-center justify-space-between mb-2">
                <span
                  class="text-caption grey--text font-weight-bold uppercase"
                  >{{ kpi.title }}</span
                >
                <v-icon small :color="kpi.color">{{ kpi.icon }}</v-icon>
              </div>
              <div class="text-h5 font-weight-black">
                {{ getCurrency }} {{ formatNumber(kpi.value) }}
              </div>
              <div
                class="text-caption mt-1"
                :class="kpi.trendUp ? 'success--text' : 'error--text'"
              >
                <v-icon x-small :color="kpi.trendUp ? 'success' : 'error'">
                  {{ kpi.trendUp ? "mdi-arrow-up" : "mdi-arrow-down" }}
                </v-icon>
                {{ kpi.subtitle }}
              </div>
            </v-card>
          </v-col>
        </v-row>

        <v-row class="mt-4">
          <v-col cols="12" md="8">

            <v-card class="rounded-lg pa-4 mb-6">
              <v-card-title class="pa-0 text-subtitle-1 font-weight-bold">
                Appointments & Events Calendar
              </v-card-title>
              <v-sheet class="mt-4">
                <AppointmentsCalendar></AppointmentsCalendar>
              </v-sheet>
            </v-card>

            
            <!-- <v-card class="rounded-lg pa-0">
              <v-tabs v-model="statusTab" :color="getThemeColor" class="px-2">
                <v-tab class="text-caption font-weight-bold"
                  >Workshop Status</v-tab
                >
                <v-tab class="text-caption font-weight-bold">Legal Files</v-tab>
              </v-tabs>
              <v-divider></v-divider>
              <DashboardTiles :tiles="tiles"></DashboardTiles>
            </v-card> -->

            

            <!-- <v-row dense>
              <v-col cols="12" sm="6">
                <v-card class="rounded-lg pa-0 overflow-hidden" height="100%">
                  <v-toolbar
                    flat
                    dense
                    color="error lighten-5"
                    class="border-bottom"
                  >
                    <v-toolbar-title
                      class="text-subtitle-2 error--text font-weight-bold"
                    >
                      <v-icon small left color="error">mdi-alert-circle</v-icon>
                      Action Required
                    </v-toolbar-title>
                  </v-toolbar>
                  <v-list dense>
                    <v-list-item v-for="item in alerts" :key="item.text">
                      <v-list-item-content>
                        <v-list-item-title class="text-body-2">{{
                          item.text
                        }}</v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-chip x-small color="error" label dark>{{
                          item.count
                        }}</v-chip>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-col>

              <v-col cols="12" sm="6">
                <v-card class="rounded-lg pa-0" height="100%">
                  <v-toolbar flat dense class="border-bottom">
                    <v-toolbar-title class="text-subtitle-2 font-weight-bold">
                      <v-icon small left>mdi-calendar-clock</v-icon> Today's
                      Schedule
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon x-small><v-icon>mdi-arrow-right</v-icon></v-btn>
                  </v-toolbar>
                  <v-list dense>
                    <v-list-item
                      v-for="app in appointments"
                      :key="app.time"
                      class="border-bottom-lite"
                    >
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-bold">{{
                          app.client
                        }}</v-list-item-title>
                        <v-list-item-subtitle
                          >{{ app.time }} - {{ app.type }}</v-list-item-subtitle
                        >
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-btn
                          icon
                          small
                          :color="getThemeColor"
                          @click="handleAction('bill')"
                        >
                          <v-icon small>mdi-receipt-text-plus</v-icon>
                        </v-btn>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-col>
            </v-row> -->

            <!-- <v-card class="rounded-lg mt-6 pa-0">
              <v-tabs v-model="statusTab" :color="getThemeColor" class="px-2">
                <v-tab class="text-caption font-weight-bold"
                  >Workshop Status</v-tab
                >
                <v-tab class="text-caption font-weight-bold">Legal Files</v-tab>
              </v-tabs>
              <v-divider></v-divider>
              <DashboardTiles :tiles="tiles"></DashboardTiles>
            </v-card> -->

            <!-- <v-row class="mt-4" dense>
              <v-col cols="12">
                <v-card class="rounded-lg pa-4">
                  <div class="text-subtitle-1 font-weight-bold mb-4">
                    Aging Report (Collections)
                  </div>
                  <v-row>
                    <v-col v-for="age in agingData" :key="age.label">
                      <div class="text-caption grey--text">{{ age.label }}</div>
                      <div class="text-h6 font-weight-bold">
                        {{ getCurrency }} {{ formatNumber(age.value) }}
                      </div>
                      <v-progress-linear
                        :value="age.percent"
                        :color="age.color"
                        height="6"
                        rounded
                        class="mt-1"
                      ></v-progress-linear>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row> -->
          </v-col>

          <v-col cols="12" md="4">
            <!-- <v-card
              class="rounded-lg pa-4 mb-6"
              :style="{ borderLeft: '4px solid ' + getThemeColor }"
            >
              <div class="text-subtitle-2 font-weight-bold mb-4">
                Daily POS Summary
              </div>
              <div
                v-for="pos in posMetrics"
                :key="pos.label"
                class="d-flex justify-space-between mb-2"
              >
                <span class="text-body-2 grey--text">{{ pos.label }}</span>
                <span class="text-body-2 font-weight-bold"
                  >{{ getCurrency }} {{ formatNumber(pos.value) }}</span
                >
              </div>
              <v-divider class="my-3"></v-divider>
              <div
                class="d-flex justify-space-between primary--text font-weight-bold"
              >
                <span>Expected Drawer</span>
                <span>{{ getCurrency }} {{ formatNumber(4250) }}</span>
              </div>
            </v-card> -->

            <v-card class="rounded-lg pa-4 mb-6 bg-gradient-light">
              <div class="d-flex justify-space-between align-center mb-4">
                <div class="text-subtitle-2 font-weight-bold">
                  Unpaid Invoices
                </div>
                <v-btn icon x-small :color="getThemeColor"
                  ><v-icon>mdi-file</v-icon></v-btn
                >
              </div>
              <v-row dense>
                <InvoiceTable
                  :invoices="unpaidInvoices"
                  @refresh-needed="$emit('refresh-data')"
                  @edit-invoice="editSelectedInvoice"
                ></InvoiceTable>
              </v-row>
            </v-card>

            <!-- <v-card class="rounded-lg pa-0 overflow-hidden">
              <v-toolbar flat dense class="border-bottom">
                <v-toolbar-title class="text-subtitle-2 font-weight-bold"
                  >Recent Activity Feed</v-toolbar-title
                >
              </v-toolbar>
              <v-card-text class="pa-0">
                <v-timeline dense align-top class="ml-n6 mt-2">
                  <v-timeline-item
                    v-for="feed in activityFeed"
                    :key="feed.id"
                    :color="feed.color"
                    small
                  >
                    <div class="text-caption font-weight-bold">
                      {{ feed.title }}
                    </div>
                    <div class="text-caption grey--text">{{ feed.time }}</div>
                  </v-timeline-item>
                </v-timeline>
              </v-card-text>
            </v-card> -->

            <v-alert
              v-if="lowStock.length > 0"
              type="warning"
              text
              class="mt-6 rounded-lg pa-2"
              icon="mdi-package-variant-closed"
            >
              <div class="text-caption font-weight-bold">
                <!-- <DashboardTiles :tiles="tiles"></DashboardTiles> -->
              </div>
            </v-alert>
          </v-col>
        </v-row>
      </div>
    </v-main>

    <v-btn fixed fab bottom right :color="getThemeColor" dark class="d-sm-none">
      <v-icon>mdi-plus</v-icon>
    </v-btn>
  </v-app>
</template>

<script>
import axios from "@/plugins/axios";
import helpersJs from "@/plugins/helpers";
import invoicesAndQuotesJs from "@/plugins/invoicesAndQuotes";
import AppointmentsCalendar from "@/modules/AppointmentsCalendar/AppointmentsCalendar.vue";
import DashboardTiles from "@/components/myLibrary/DashboardTiles.vue";
import InvoiceTable from "@/components/InvoicesAndQuotes/InvoiceTable.vue";
export default {
  components: {
    AppointmentsCalendar,
    DashboardTiles,
    InvoiceTable,
  },
  data: () => ({
    invoicesAndQuotesData: null,
    allInvoices: [],
    allQuotes: [],
    unpaidInvoices: [],
    drawer: null,
    statusTab: 0,
    // --- Dashboard Static Data ---
    menuItems: [
      {
        title: "Manage User",
        icon: "mdi-account-multiple",
        route: "manage-users",
      },
      {
        title: "Clients / Patients",
        icon: "mdi-account-group",
        route: "manage-clients",
      },
      {
        title: "Add / Edit Any Data",
        icon: "mdi-account-multiple",
        route: "data-crud",
      },
      {
        title: "Billing & Invoices",
        icon: "mdi-file-document-edit",
        route: "invoices-and-quotes",
      },
      {
        title: "POS / Sales",
        icon: "mdi-cash-register",
        route: "point-of-sale",
      },
      {
        title: "Schedule",
        icon: "mdi-calendar",
        route: "bulk-emails-dashboard",
      },
      {
        title: "Site Images",
        icon: "mdi-image",
        route: "website-dashboard",
      },
      {
        title: "Staff & Payroll",
        icon: "mdi-account-tie",
        route: "manage-employees",
      },
      { title: "Products & Services", 
        icon: "mdi-package-variant",
        route: "manage-products" 
      },
      {
        title: "SMS & Email Marketing",
        icon: "mdi-email",
        route: "bulk-emails-dashboard",
      },
    ],
    quickActions: [
      {
        title: "New Invoice",
        icon: "mdi-file-plus",
        color: "blue",
        action: "invoice",
      },
      {
        title: "Record Payment",
        icon: "mdi-currency-usd",
        color: "success",
        action: "payment",
      },
      {
        title: "Add Client",
        icon: "mdi-account-plus",
        color: "orange",
        action: "client",
      },
      {
        title: "Start Timer",
        icon: "mdi-timer-outline",
        color: "purple",
        action: "timer",
      },
    ],
    // --- UI/UX Header Config ---
    jobHeaders: [
      { text: "Reference", value: "ref" },
      { text: "Client / Vehicle", value: "client" },
      { text: "Status", value: "status" },
      { text: "Owner", value: "owner" },
    ],
    // --- Simulated Backend Data ---
    financialKPIs: [
      {
        title: "Today's Revenue",
        value: 0,
        icon: "mdi-currency-usd",
        color: "success",
        trendUp: true,
        subtitle: "12% vs yesterday",
      },
      {
        title: "Month to Date",
        value: 0,
        icon: "mdi-calendar-check",
        color: "info",
        trendUp: true,
        subtitle: "5% vs last month",
      },
      {
        title: "Total Payments Received",
        value: 0,
        icon: "mdi-cash-multiple",
        color: "purple",
        trendUp: true,
        subtitle: "14 new this week",
      },
      {
        title: "Total Outstanding Invoices",
        value: 0,
        icon: "mdi-clock-alert",
        color: "error",
        trendUp: false,
        subtitle: "22 Overdue",
      },
    ],
    tiles: [
      // {
      //   id: 2,
      //   icon: "mdi-account-multiple",
      //   title: "Manage Clients",
      //   industry: ["General"],
      //   route: "manage-clients",
      //   param: "",
      //   alevel: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      //   buttonText: "Enter",
      // },
      // {
      //   id: 2,
      //   icon: "mdi-cart-arrow-right",
      //   title: "Products & Services",
      //   industry: ["General", "Store", "IT"],
      //   route: "manage-products",
      //   param: "",
      //   alevel: [7, 8, 9, 10, 11, 12, 13, 14, 15],
      //   buttonText: "Enter",
      // },

      // {
      //   id: 3,
      //   icon: "mdi-network-pos",
      //   title: "Point Of Sale",
      //   industry: ["General", "Store"],
      //   route: "point-of-sale",
      //   param: "",
      //   alevel: [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      //   buttonText: "Enter",
      // },
      // {
      //   id: 3,
      //   icon: "mdi-network-pos",
      //   title: "Activity Tracker",
      //   industry: ["General"],
      //   route: "activity-tracker",
      //   param: "",
      //   alevel: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      //   buttonText: "Enter",
      // },
      // {
      //   id: 3,
      //   icon: "mdi-account-group",
      //   title: "Talents",
      //   industry: ["Agency"],
      //   route: "manage-talents",
      //   param: "",
      //   alevel: [7, 8, 9, 10, 11, 12, 13, 14, 15],
      //   buttonText: "Enter",
      // },
      // {
      //   id: 3,
      //   icon: "mdi-receipt",
      //   title: "Invoices & Quotes",
      //   industry: ["General", "Store", "IT"],

      //   route: "invoices-and-quotes",
      //   param: "",
      //   alevel: [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      //   buttonText: "Enter",
      // },
      // {
      //   id: 7,
      //   icon: "mdi-pencil",
      //   title: "Edit Any Data",
      //   industry: ["General"],

      //   route: "data-crud",
      //   param: "",
      //   alevel: [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      //   buttonText: "Enter",
      // },
      // {
      //   id: 2,
      //   icon: "mdi-file",
      //   title: "Filing",
      //   industry: ["Legal Practice"],
      //   route: "manage-files",
      //   param: "",
      //   alevel: [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      //   buttonText: "Enter",
      // },

      // {
      //   id: 3,
      //   icon: "mdi-Company",
      //   title: "E-learning",
      //   industry: ["General"],

      //   route: "elearning",
      //   param: "",
      //   alevel: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      //   buttonText: "Enter"
      // },
      // {
      //   id: 3,
      //   icon: "mdi-Company",
      //   title: "Billings",
      //   industry: ["General", "Legal Practice"],
      //   route: "billings",
      //   param: "",
      //   alevel: [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      //   buttonText: "Enter",
      // },
      // {
      //   id: 3,
      //   icon: "mdi-store",
      //   title: "Store",
      //   industry: ["General"],

      //   route: "web-store",
      //   param: "",
      //   alevel: [1,2,3,4,5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      //   buttonText: "Enter",
      // },

      // {
      //   id: 9,
      //   icon: "mdi-comment",
      //   title: "Bulk SMS",
      //   industry: ["General"],
      //   route: "bulk-sms-dashboard",
      //   param: "",
      //   alevel: [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      //   buttonText: "Enter",
      // },
      // {
      //   id: 2,
      //   icon: "mdi-office",
      //   title: "Word",
      //   industry: ["General", "Legal Practice"],
      //   route: "word-editor",
      //   param: "",
      //   alevel: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      //   buttonText: "Enter",
      // },
      // {
      //   id: 2,
      //   icon: "mdi-office",
      //   title: "Explorer",
      //   industry: ["General", "Legal Practice"],
      //   route: "file-manager",
      //   param: "",
      //   alevel: [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      //   buttonText: "Enter",
      // },

      // {
      //   id: 9,
      //   icon: "mdi-account-multiple",
      //   title: "HR & Staff",
      //   industry: ["General"],
      //   route: "manage-employees",
      //   param: "",
      //   alevel: [9, 10, 11, 12, 13, 14, 15],
      //   buttonText: "Enter",
      // },
      // {
      //   id: 9,
      //   icon: "mdi-account-cash",
      //   title: "Payslips",
      //   industry: ["General"],

      //   route: "salaries-and-payslips",
      //   param: "",
      //   alevel: [9, 10, 11, 12, 13, 14, 15],
      //   buttonText: "Enter",
      // },
      // {
      //   id: 4,
      //   icon: "mdi-credit-card-marker-outline",
      //   title: "Pay Online",
      //   industry: ["General", "Legal Practice"],

      //   route: "pay-online",
      //   param: "",
      //   alevel: [3, 4, 5, 6, 15],
      //   buttonText: "Enter",
      // },
      // {
      //   id: 7,
      //   icon: "mdi-file",
      //   title: "Reports",
      //   industry: ["General", "Legal Practice"],

      //   route: "data-and-reports",
      //   param: "",
      //   alevel: [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      //   buttonText: "Enter",
      // },
      // {
      //   id: 9,
      //   icon: "mdi-calendar",
      //   title: "Events",
      //   industry: ["General"],

      //   route: "events-calendar",
      //   param: "",
      //   alevel: [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      //   buttonText: "Enter",
      // },

      // {
      //   id: 9,
      //   icon: "mdi-cog",
      //   title: "Company Profile",
      //   industry: ["General"],

      //   route: "settings",
      //   param: "",
      //   alevel: [7, 8, 9, 10, 11, 12, 13, 14, 15],
      //   buttonText: "Enter",
      // },

      // {
      //   id: 9,
      //   icon: "mdi-account-multiple",
      //   title: "Manage Users",
      //   industry: ["General"],

      //   route: "manage-users",
      //   param: "",
      //   alevel: [7, 8, 9, 10, 11, 12, 13, 14, 15],
      //   buttonText: "Enter",
      // },
      // {
      //   id: 10,
      //   icon: "mdi-card-account-mail",
      //   title: "Enquiries",
      //   industry: ["General", "Legal Practice"],

      //   route: "",
      //   param: "",
      //   alevel: [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      //   buttonText: "Enter",
      // },

      // {
      //   id: 10,
      //   icon: "mdi-play",
      //   title: "Tutorials",
      //   industry: ["General"],
      //   route: "video-tutorials",
      //   param: "",
      //   alevel: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      //   buttonText: "Enter",
      // },
    ],
  }),

  computed: {
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getCompanyLabels() {
      return this.$store.getters.getCompanyLabels;
    },
    getClientLabel() {
      return this.$store.getters.getCompanyLabels.client;
    },
    getCurrentUser() {
      return this.$store.getters.getCurrentUser;
    },
    getUserCompany() {
      return this.$store.getters.getUserCompany;
    },
    getCurrency() {
      return this.$store.getters.getCurrency;
    },
    getCurrentUser() {
      return this.$store.getters.getCurrentUser;
    },

    posMetrics() {
      return [
        { label: "Cash Sales Today", value: 1200 },
        { label: "Card Sales Today", value: 8500 },
        { label: "EFT / Mobile", value: 2750 },
        { label: "Refunds Issued", value: -450 },
      ];
    },
    alerts() {
      return [
        { text: "Unbilled Time Entries", count: 14 },
        { text: "Draft Invoices Sent", count: 5 },
        { text: "Low Trust Balance", count: 2 },
        { text: "Failed Payments", count: 1 },
      ];
    },
    appointments() {
      return [
        { time: "09:00 AM", client: "Sarah Jenkins", type: "Consultation" },
        {
          time: "11:30 AM",
          client: "Toyota Hilux (KLY 001 GP)",
          type: "Major Service",
        },
        {
          time: "02:00 PM",
          client: "M. Mokoena",
          type: "High Court Appearance",
        },
      ];
    },
    jobItems() {
      return [
        {
          ref: "JOB-902",
          client: "BMW X5 (JSB 201 GP)",
          status: "In Progress",
          owner: "Mike",
        },
        {
          ref: "FILE-2024-01",
          client: "State vs Smith",
          status: "Awaiting Doc",
          owner: "Sarah",
        },
        {
          ref: "JOB-881",
          client: "Ford Ranger (LMN 445 GP)",
          status: "Completed",
          owner: "Mike",
        },
      ];
    },
    agingData() {
      return [
        { label: "Current", value: 45000, percent: 60, color: "success" },
        { label: "30 Days", value: 25000, percent: 30, color: "warning" },
        { label: "60+ Days", value: 19000, percent: 10, color: "error" },
      ];
    },
    revenueChart() {
      return {
        labels: ["M", "T", "W", "T", "F", "S", "S"],
        data: [12, 18, 15, 25, 32, 10, 5],
      };
    },
    activityFeed() {
      return [
        {
          id: 1,
          title: "Invoice #1092 viewed by client",
          time: "2 mins ago",
          color: "info",
        },
        {
          id: 2,
          title: "Payment of R5,000 received",
          time: "45 mins ago",
          color: "success",
        },
        {
          id: 3,
          title: "SMS Reminder sent to J. Doe",
          time: "1 hour ago",
          color: "grey",
        },
      ];
    },
    lowStock() {
      return ["Brake Pads (Toyota)", "Oil Filter (Generic)"];
    },
  },
  async mounted() {
    await this.setUserEmis(this.getCurrentUser.emis);
    await this.getInvoicesAndQuotesData();
  },
  methods: {
    renameTiles() {
      this.tiles.forEach((tile) => {
        if (tile.title.includes("lient")) {
          tile.title = "Manage " + this.getCompanyLabels.client + "s";
        } else if (tile.title.includes("ervice")) {
          tile.title =
            this.getCompanyLabels.products +
            " & " +
            this.getCompanyLabels.services;
        }
      });
    },
    goToRoute(route) {
      this.$router.push({ name: route });
    },
    editSelectedInvoice() {
      //helicopter parents
    },
    formatNumber(val) {
      if (val === null || val === undefined) return "0";
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
    getStatusColor(status) {
      if (status === "In Progress") return "blue";
      if (status === "Completed") return "success";
      if (status === "Awaiting Doc") return "orange";
      return "grey";
    },
    handleAction(action) {
      console.log("Triggered Action: " + action);
      // Logic for new invoice, payment, etc.
    },
    async getInvoicesAndQuotesData() {
      this.$store.commit("setLoader", true);
      this.invoicesAndQuotesData =
        await invoicesAndQuotesJs.getInvoicesAndQuotesData();

      this.allInvoices = this.invoicesAndQuotesData.invoices;

      this.unpaidInvoices = [];
      let totalInvoiced = 0;
      let totalPaymentsReceived = 0;
      let totalOutstanding = 0;

      this.allInvoices.forEach((invoice) => {
        const invoiceTotal = helpersJs.stripNonDigitsAndCommasFromMoney(
          invoice.calculation.total
        );
        totalInvoiced += Number(invoiceTotal);
        totalPaymentsReceived += Number(invoice.totalPayment);

        if (invoiceTotal > invoice.totalPayment) {
          this.unpaidInvoices.push(invoice);
        }
      });
      totalOutstanding = totalInvoiced - totalPaymentsReceived;
      this.financialKPIs[0].value = totalInvoiced;
      this.financialKPIs[2].value = totalPaymentsReceived;
      this.financialKPIs[3].value = totalOutstanding;

      this.$store.commit("setLoader", false);
    },
    async setUserEmis(emis) {
      const data = await axios.postDataWithToken(
        "/auth/get-selected-company",
        { emis },
        this.getAccessToken
      );

      if (data == "unauthorized") {
        //this.overlay = true;
        //this.unauthorized = true;
      } else {
        helpersJs.initialiseOrUpdateCompanyDataInStorage(
          data.company,
          data.company.site_colors,
          data.user
        );

        this.$store.commit("setCurrency", data.company.currency);
        localStorage.setItem("currency", data.company.currency);
        localStorage.setItem(
          "companyLabels",
          JSON.stringify(data.company.labels)
        );

        this.renameTiles();
        //this.renameClient();
        //this.initialiseDashboard();

        //this.getLogos(data.company.emis);

        //this.overlay = false;
      }
    },
  },
};
</script>

<style scoped>
.border-bottom {
  border-bottom: 1px solid #e0e4e8 !important;
}
.border-bottom-lite {
  border-bottom: 1px solid #f0f2f5 !important;
}
.bg-gradient-light {
  background: linear-gradient(135deg, #ffffff 0%, #f0f4ff 100%);
}
.uppercase {
  text-transform: uppercase;
  letter-spacing: 1px;
}
/* Transitions for hover effects */
.v-card {
  transition: transform 0.2s ease-in-out;
}
.v-card:hover {
  transform: translateY(-2px);
}
</style>
